"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ContentFilterSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7,7.70710678 L4.34142136,5.04852814 C3.87279221,4.57989899 3.87279221,3.82010101 4.34142136,3.35147186 C4.56646501,3.12642821 4.87168971,3 5.18994949,3 L12.8100505,3 C13.4727922,3 14.0100505,3.5372583 14.0100505,4.2 C14.0100505,4.51825979 13.8836223,4.82348448 13.6585786,5.04852814 L11,7.70710678 L11,12.7675919 L7.7773501,14.9160251 C7.46920776,15.1207581 7,14.9599304 7,14.5 L7,7.70710678 Z M10,7.29289322 L12.9514719,4.34142136 C13.0799561,4.14950562 12.9205075,4 12.8100505,4 L5.18994949,4 C4.99110413,4 4.97042328,4.2633165 5.04852814,4.34142136 L8,7.29289322 L8,13.5657415 L10,12.2324081 L10,7.29289322 Z" })));
};
ContentFilterSmall.displayName = 'ContentFilterSmall';
exports.default = ContentFilterSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ContentFilterSmall.js.map